module.exports = __webpack_public_path__ + "img/wa-icon.dd95a6ee.svg";